import { PiCaretDownDuotone, PiCaretLeftDuotone, PiCaretRightDuotone } from "react-icons/pi";
import React, { useState, useEffect } from "react";
import { motion } from 'framer-motion';

const testimonials = [
    {
        text: "Marketing gyakornokként dolgozom, elősorban a különböző marketing anyagok elkészítésével és legyártatásával foglalkozom. Számomra ez azért nagyon kedvelt faladat mert nagyon szeretek kreatív lenni, és használni a fantáziámat. Viszonylag kicsi csapatban dolgozom, de mindig nagyon jó a hangulat, mindig együtt eszünk, nagyon jól tudunk kommunikálni, nagyon jó a csoportdinamika, és ezért nagyon hálás lehetek. Teljes mértékben órarend barát a beosztás, és a feletteseim tisztelik, és tudják, hogy számomra az egyetemi tanulmányaim a legfontosabbak, véleményem szerint ez egy nagyon kivételes dolog.",
        author: "K. Orsolya"
    },
    {
        text: "Helyileg egy kicsit messze van a gyakornoki helyem, home officera egyelőre nincsen még lehetőség, de ennek ellenére a csapatmorál tökéletes, nagyon segítőkész minden kolléga. A fizetés abszolút korrekt. IT gyakornoki pozícióban dolgozom jelenleg, leginkább azt szeretem a munkámban, hogy számítógépen keresztül elérhetek más gépeket távolról, illetve admin jogokkal rendelkezem, és nagyobb projekteben vehetek részt, és segíthetem a vállalt fejlődédét. A munkahelyi étterem kiváló, illetve még kiemelkedően jónak tartom a sportolási lehetőséget cégen belül. A főnökök nagyon támogatóak gyakornokaikkal, és mindig szakmai segítséget is nyújtanak.",
        author: "B. M. Zsolt"
    },
    {
        text: "Jól érzem magam a csapatban. Elősorban az a feladatom, hogy segítsem a főállású dolgozókat, ami engem nagyon jó érzéssel tölt el, hogy meg tudom könnyíteni a mindennapi munkájukat. Rugalmas, órarendbarát a beosztás. Lehet home officeban is dolgozni, ez az, ami miatt tuti nem váltanék gyakornoki helyet.",
        author: "Sz. Károly"
    },
    {
        text: "Nagyon szeretem a munkahelyi csapatot, nagyon segítőkészek, illetve nem csak kávét főzök, hanem valódi szakmai tudásra tehetek szert nap mint nap. Nagyon jók a vezetők, szakmai segítséget nyújtanak mindenben. Rendezett az irodai környezet, hétfőtől péntekig tart az irodai munkavégzés, rugalmas beosztással és szabad hétvégékkel, de egyébként home officra is van lehetőség.",
        author: "Z. Tünde Édua"
    },
    {
        text: "Egyetemi szakmai gyakorlatomat nagyon szeretem, nagyon jó a csapat, sokat tanulok szakmailag, és úgy tűnik ők is nagyon meg vannak velem elégedve, mivel eredetileg úgy volt, hogy év végig dolgozom majd náluk, és ezt most a vezetőség meghosszabbította egy fél évvel. A cég megközelíthetősége szuper, igazi multis a környezet. Az iroda gyönyörű, nagyon odafigyelnek környezettudatosságra. Szeptember elejéig nem kellett irodán dolgoznunk, és most a vírus miatt teljesen önkéntes a bejárás. A csapat fiatalos, lendületes, és csajos, illetve nagyon összetartó. Ami a legpozitívabb, hogy mindenki rengeteget dolgozik, mégis mindig elérhetőek a kollégák, és a segítségemre vannak.",
        author: "H. Sára Rebeka"
    }
];

export default function GyakornokMainPage() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);
    const transitionDuration = 500;

    const nextTestimonial = () => {
        setFade(false); 
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length); 
            setFade(true); 
        }, transitionDuration);
    };

    const prevTestimonial = () => {
        setFade(false); 
        setTimeout(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
            ); 
            setFade(true); 
        }, transitionDuration);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextTestimonial();
        }, 8000); 

        return () => clearInterval(interval); 
    }, []);

    return (
        <div className='min-h-screen'>
            <div className='w-full flex flex-col gap-4 min-h-screen font-display' 
                style={{
                    backgroundImage: 'url(/assets/images/background/pattern-opacity.png)',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                }}
            >
                <div className="w-full flex flex-col min-h-screen relative overflow-hidden rounded-3xl">
                    <div
                        className='w-full h-full absolute top-0 left-0'
                        style={{
                            backgroundImage: 'url(/assets/images/background/asztalibanner1.jpg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center top',
                        }}
                    />

                    <div className="w-full h-full absolute top-0 left-0 flex flex-col items-center justify-center gap-4">
                        <div className="flex flex-col gap-4 justify-center items-center text-center mx-4 sm:mx-4 md:mx-10 lg:mx-20 xl:mx-20 2xl:mx-20">
                            <div className=" font-black text-orange-500 text-3xl sm:text-3xl md:text-6xl lg:text-7xl xl:text-7xl 2xl:text-7xl">
                                Gyakornoki állásaink megalapozzák a jövőd és a karriered
                            </div>
                            <div className="w-full text-white text-base sm:text-base md:text-2xl lg:text-3xl xl:text-2xl 2xl:text-2xl">
                                Szeretnéd már az egyetemi éveid alatt kipróbálni a gyakorlatban tanulmányaidat?
                                <br/>
                                Érdekel, hogyan néz ki a szakmai területed a mindennapokban?
                                <br/>
                                Találd meg a hozzád közelebb álló gyakornoki helyet! 
                            </div>
                            <button
                                className="p-4 text-white bg-gradient-to-r from-orange-500 to-orange-800 text-xs sm:text-xs md:text-2xl lg:text-2xl xl:text-xl 2xl:text-xl 
                                            rounded-lg transition duration-200 hover:ring-8 ring-white/20 hover:scale-105"
                            >
                                Megnézem az állásokat
                            </button>
                        </div>

                        <div className="group flex flex-col items-center mt-20 cursor-pointer transition-transform duration-200 transform hover:scale-110 text-white hover:text-orange-500"
                            onClick={() => document.getElementById('below-meki-section').scrollIntoView({ behavior: 'smooth' })}
                        >
                            <div className="text-white text-sm sm:text-sm md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-2xl">
                                Olvass tovább
                            </div>
                            <PiCaretDownDuotone className="size-24 mt-[-24px]"/>
                        </div>
                    </div>
                </div>

                <div id="below-meki-section" className="relative flex flex-col text-center gap-4">
                    <h1 className=" font-bold text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-6xl 2xl:text-7xl">
                        <span
                            className="relative inline-block"
                            style={{
                                backgroundImage: 'url(/assets/images/artifacts/mitol_jo_hatter.svg)',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                padding: '4px 12px', 
                                display: 'inline-block',
                            }}
                        >
                            Miért jó,
                        </span>
                        <br/>
                    </h1>
                    <h1 className="font-bold text-orange-500 text-3xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-5xl 2xl:text-5xl">
                        Fürge Gyakornoknak lenni? 
                    </h1>
                    <div className="flex flex-col gap-4 p-4 sm:p-4 md:p-8 lg:p-8 xl:p-8 2xl:p-8">
                        <div className="font-bold text-orange-500 text-lg sm:text-lg md:text-3xl lg:text-4xl xl:text-3xl 2xl:text-3xl">
                            Gyakorlati tapasztalat
                        </div>
                        <div className="text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg">
                            Nagy figyelmet fordítunk arra, hogy gyakornoki időd alatt tényleges szakmai tudást szerezz. Az általunk közvetített gyakornoki programok 
                            sokszínűek, szakmai tudást, kapcsolatépítést és olyan lehetőségeket adnak, amik a munkaerőpiacra kilépve előnyt jelentenek.
                        </div>
                    </div>

                    <div className="flex flex-col gap-4 p-4 sm:p-4 md:p-8 lg:p-8 xl:p-8 2xl:p-8">
                        <div className="font-bold text-orange-500 text-lg sm:text-lg md:text-3xl lg:text-4xl xl:text-3xl 2xl:text-3xl">
                            Szakmai területek
                        </div>
                        <div className="text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg">
                            Jelenlegi partnercégeink az IT/ programozás, különböző mérnöki (vegyipari mérnök, biomérnök, gépészmérnök, villamosmérnök), HR, 
                            marketing, kommunikáció, gazdasági, pénzügyi, műszaki területeken tevékenykednek. Ezek mellett, folyamatosan bővítjük a gyakornoki 
                            pozícióink palettáját. Célunk, hogy minél többféle lehetőség közül tudd kiválasztani a számodra megfelelő állást és megtapasztald, hogy 
                            milyen a tanult szakmádban dolgozni.
                        </div>
                    </div>

                    <div className="flex flex-col gap-4 p-4 sm:p-4 md:p-8 lg:p-8 xl:p-8 2xl:p-8">
                        <div className="font-bold text-orange-500 text-lg sm:text-lg md:text-3xl lg:text-4xl xl:text-3xl 2xl:text-3xl">
                            Idegennyelv-tudás
                        </div>
                        <div className="text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg">
                            Ha már magabiztos idegennyelv-tudásod van és szívesen használnád a mindennapokban vagy fejlesztenéd még, akkor nálunk 
                            nyelvtudásodhoz passzoló állásokat is találsz. Közép-és nagyvállalati partnerinknél többnyire az angol nyelv legalább B2-es szintű 
                            ismerete szükséges. Ha emellett más idegennyelveket is beszélsz, csak előnyödre válik.
                        </div>
                    </div>

                    <div className="flex flex-col gap-4 p-4 sm:p-4 md:p-8 lg:p-8 xl:p-8 2xl:p-8">
                        <div className="font-bold text-orange-500 text-lg sm:text-lg md:text-3xl lg:text-4xl xl:text-3xl 2xl:text-3xl">
                            Hosszútávú lehetőség
                        </div>
                        <div className="text-white text-xs sm:text-xs md:text-base lg:text-xl xl:text-lg 2xl:text-lg">
                            Ha nem csak a kötelező szakmai gyakorlat teljesítése a célod, hanem hosszútávra tervezel, akkor fontos kiemelnünk, hogy több 
                            partnerünknél van lehetőség a pozíciók közötti váltásra, illetve tapasztalataink alapján partnercégeink gyakran biztosítanak főállású 
                            munkaviszonyt, a tanulmányaid befejezése után.
                        </div>
                    </div>
                </div>

                <div className="w-full h-[450px] md:h-[600px] lg:h-[650px] xl:h-[600px] flex flex-col relative overflow-hidden rounded-3xl p-8 md:p-10 xl:p-20">
                    <div
                        className="absolute inset-0 w-full h-full"
                        style={{
                            backgroundImage: 'url(/assets/images/background/asztalibanner2.jpg)',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />

                    <div className="relative z-10 w-full text-center  font-black text-orange-500 text-3xl md:text-5xl lg:text-6xl">
                        Mit mondanak jelenlegi Fürge Gyakornokaink?
                    </div>
                    <br/>
                    <motion.div
                        key={currentIndex} 
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.95 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                        className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center text-white px-6 md:px-20 lg:px-40 xl:px-60"
                    >
                        <div className="max-w-3xl text-[0.55rem] sm:text-[0.55rem] md:text-base lg:text-xl xl:text-lg">
                            "{testimonials[currentIndex].text}"
                        </div>
                        <div className="font-black text-orange-500 text-sm md:text-3xl lg:text-4xl xl:text-3xl">
                            {testimonials[currentIndex].author}
                        </div>
                    </motion.div>

                    <div className="absolute inset-y-0 left-0 lg:left-4 flex items-center">
                        <button
                            className="relative z-20 cursor-pointer transition-transform duration-200 transform hover:scale-110 text-white hover:text-orange-500 text-3xl md:text-7xl"
                            onClick={prevTestimonial}
                        >
                            <PiCaretLeftDuotone/>
                        </button>
                    </div>
                    <div className="absolute inset-y-0 right-0 lg:right-4 flex items-center">
                        <button
                            className="relative z-20 cursor-pointer transition-transform duration-200 transform hover:scale-110 text-white hover:text-orange-500 text-3xl md:text-7xl"
                            onClick={nextTestimonial}
                        >
                            <PiCaretRightDuotone/>
                        </button>
                    </div>
                </div>
                <br/>
                <br/>
                
                <div id="below-meki-section" className="relative text-center flex flex-col gap-4">
                    <h1 className=" font-bold text-2xl sm:text-4xl md:text-5xl lg:text-6xl">
                        <span
                            className="relative inline-block"
                            style={{
                                backgroundImage: 'url(/assets/images/artifacts/mitol_jo_hatter.svg)',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                padding: '4px 12px', 
                                display: 'inline-block',
                            }}
                        >
                            Gyakornoki
                        </span>
                        <br/>
                    </h1>
                    <h1 className="font-bold text-orange-500 text-3xl md:text-4xl lg:text-5xl">
                        területeink
                    </h1>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 justify-center items-center xl:items-start gap-12 p-8 md:p-10 xl:p-20">
                    <div className="flex flex-col w-full h-96 gradient-gray rounded-2xl shadow-2xl overflow-hidden transition duration-200 border-4 border-orange-500 hover:border-0 ring-8 ring-white/20 hover:ring-orange-500 hover:scale-105 group">
                        <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl" 
                            style={{ backgroundImage: 'url(/assets/images/penzugy_asztali.jpg)' }}>
                            <div className="absolute bottom-[-26px] md:bottom-[-28px] lg:bottom-[-32px] xl:bottom-[-34px] 2xl:bottom-[-36px] left-4 lg:left-6 size-14 md:size-12 lg:size-14 xl:size-16
                                            bg-white rounded-full flex items-center justify-center shadow-2xl">
                                <img src="/assets/images/icons/penzugy_narancs.svg" alt="Pénzügy Icon" className="size-8 md:size-6 lg:size-8 xl:size-10" />
                            </div>
                        </div>
                        <div className="p-4 text-center gradient-gray">
                            <p className="font-black text-orange-500 text-xl sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-2xl">
                                Pénzügy
                            </p>
                            <br/>
                            <p className="text-white text-base sm:text-base md:text-lg lg:text-lg xl:text-lg 2xl:text-lg">
                                számvitel, pénzügyi jog,
                                <br/>
                                adójog, adótanácsadás
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col w-full h-96 gradient-gray rounded-2xl 
                                    shadow-2xl overflow-hidden transition duration-200 border-4 border-orange-500 hover:border-0 ring-8 ring-white/20 hover:ring-orange-500 hover:scale-105 group">
                        <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl" 
                            style={{ backgroundImage: 'url(/assets/images/informatika_asztali.jpg)' }}>
                            <div className="absolute bottom-[-26px] md:bottom-[-28px] lg:bottom-[-32px] xl:bottom-[-34px] 2xl:bottom-[-36px] left-4 lg:left-6 size-14 md:size-12 lg:size-14 xl:size-16
                                            bg-white rounded-full flex items-center justify-center shadow-2xl">
                                <img src="/assets/images/icons/informatika_narancs.svg" alt="Informatika Icon" className="size-8 md:size-6 lg:size-8 xl:size-10" />
                            </div>
                        </div>
                        <div className="p-4 text-center gradient-gray">
                            <p className="font-black text-orange-500 text-xl md:text-2xl">
                                Informatika
                            </p>
                            <br/>
                            <p className="text-white text-base md:text-lg">
                                rendszerinformatika,
                                <br/>
                                szoftver- és applikációfejlesztés
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col w-full h-96 gradient-gray rounded-2xl 
                                    shadow-2xl overflow-hidden transition duration-200 border-4 border-orange-500 hover:border-0 ring-8 ring-white/20 hover:ring-orange-500 hover:scale-105 group">
                        <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl" 
                            style={{ backgroundImage: 'url(/assets/images/szemelyugy_asztali.jpg)' }}>
                            <div className="absolute bottom-[-26px] md:bottom-[-28px] lg:bottom-[-32px] xl:bottom-[-34px] 2xl:bottom-[-36px] left-4 lg:left-6 size-14 md:size-12 lg:size-14 xl:size-16 
                                            bg-white rounded-full flex items-center justify-center shadow-2xl">
                                <img src="/assets/images/icons/szemelyugy_narancs.svg" alt="Személyügy Icon" className="size-8 md:size-6 lg:size-8 xl:size-10" />
                            </div>
                        </div>
                        <div className="p-4 text-center gradient-gray">
                            <p className="font-black text-orange-500 text-xl md:text-2xl">
                                Személyügy
                            </p>
                            <br/>
                            <p className="text-white text-base md:text-lg">
                                HR,
                                <br/>
                                munkaügy
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col w-full h-96 gradient-gray rounded-2xl 
                                    shadow-2xl overflow-hidden transition duration-200 border-4 border-orange-500 hover:border-0 ring-8 ring-white/20 hover:ring-orange-500 hover:scale-105 group">
                        <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl" 
                            style={{ backgroundImage: 'url(/assets/images/marketing_asztali.jpg)' }}>
                            <div className="absolute bottom-[-26px] md:bottom-[-28px] lg:bottom-[-32px] xl:bottom-[-34px] 2xl:bottom-[-36px] 
                                            left-4 lg:left-6 size-14 md:size-12 lg:size-14 xl:size-16 
                                            bg-white rounded-full flex items-center justify-center shadow-2xl">
                                <img src="/assets/images/icons/marketing_narancs.svg" alt="Marketing Icon" className="size-8 md:size-6 lg:size-8 xl:size-10" />
                            </div>
                        </div>
                        <div className="p-4 text-center gradient-gray">
                            <p className="font-black text-orange-500 text-xl md:text-2xl">
                                Marketing
                            </p>
                            <br/>
                            <p className="text-white text-base md:text-lg">
                                marketing,
                                <br/>
                                kommunikáció, PR
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col w-full h-96 gradient-gray rounded-2xl 
                                    shadow-2xl overflow-hidden transition duration-200 border-4 border-orange-500 hover:border-0 ring-8 ring-white/20 hover:ring-orange-500 hover:scale-105 group">
                        <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl" 
                            style={{ backgroundImage: 'url(/assets/images/logisztika_asztali.jpg)' }}>
                            <div className="absolute bottom-[-26px] md:bottom-[-28px] lg:bottom-[-32px] xl:bottom-[-34px] 2xl:bottom-[-36px] left-4 lg:left-6 size-14 md:size-12 lg:size-14 xl:size-16 
                                            bg-white rounded-full flex items-center justify-center shadow-2xl">
                                <img src="/assets/images/icons/logisztika_narancs.svg" alt="Logisztika Icon" className="size-8 md:size-6 lg:size-8 xl:size-10" />
                            </div>
                        </div>
                        <div className="p-4 text-center gradient-gray">
                            <p className="font-black text-orange-500 text-xl md:text-2xl">
                                Logisztika
                            </p>
                            <br/>
                            <p className="text-white text-base md:text-lg">
                                logisztika,
                                <br/>
                                szállítmányozás
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col w-full h-96 gradient-gray rounded-2xl 
                                    shadow-2xl overflow-hidden transition duration-200 border-4 border-orange-500 hover:border-0 ring-8 ring-white/20 hover:ring-orange-500 hover:scale-105 group">
                        <div className="relative z-10 w-full h-52 bg-cover bg-center rounded-xl" 
                            style={{ backgroundImage: 'url(/assets/images/mernok_asztali.jpg)' }}>
                            <div className="absolute bottom-[-26px] md:bottom-[-28px] lg:bottom-[-32px] xl:bottom-[-34px] 2xl:bottom-[-36px] left-4 lg:left-6 size-14 md:size-12 lg:size-14 xl:size-16 
                                            bg-white rounded-full flex items-center justify-center shadow-2xl">
                                <img src="/assets/images/icons/mernok_narancs.svg" alt="Mérnök Icon" className="size-8 md:size-6 lg:size-8 xl:size-10" />
                            </div>
                        </div>
                        <div className="p-4 text-center gradient-gray">
                            <p className="font-black text-orange-500 text-xl md:text-2xl">
                                Mérnök 
                            </p>
                            <br/>
                            <p className="text-white text-base md:text-lg">
                                gépészmérnök, üzem mérnök,
                                <br/>
                                informatikai mérnök
                            </p>
                        </div>
                    </div>
                </div>

                <div className="w-full h-full flex items-center justify-center mb-16">
                    <button
                        className="p-4 text-white bg-gradient-to-r from-orange-500 to-orange-800 text-xs md:text-2xl xl:text-xl
                                   shadow-2xl rounded-lg transition duration-200 hover:ring-8 ring-white/20 hover:scale-105"
                    >
                        Megnézem az állásokat
                    </button>
                </div>
            </div>
        </div>
    );
}
